export const environment = {
    name: 'dev',
    apiEndpoint: 'https://utcsm8tk9b.execute-api.us-east-1.amazonaws.com/prod',
    mediaBaseUrl: 'https://dev.swinglabmedia.krummy.net/',
    authCookieExpireDays: 10
}